// Module
var code = "<h2>Server Metrics</h2> <div class=\"filter\"></div> <div class=\"content\"> <div class=\"separator\"> <div class=\"list\"></div> <div class=\"data\"> <div class=\"chart\" id=\"chartBox\"></div> <div class=\"msgBox\"></div> </div> </div> </div> ";
// Exports
export default code;